import type { CalibrationJSONObject, CaptureFileJSONObject } from '@ikegps/core-api';
import { CollectionModel } from '../../collection.data';

export type CaptureCalibrationPair = { capture: CaptureFileJSONObject; calibration: CalibrationJSONObject };

export interface CaptureProvider {
	getOwnedCaptures(): CaptureFileJSONObject[];
	getOwnedCaptureIds(): string[];
	getCaptures(): CaptureFileJSONObject[];
	getCaptureIds(): string[];
}

export class CaptureProviderHelpers {
	static isCaptureProvider(c): c is CaptureProvider {
		return typeof c.getCaptures === 'function';
	}

	static getCaptures(c: CollectionModel): CaptureFileJSONObject[] {
		const collections: CaptureFileJSONObject[] = [];

		c.forEachField((field) => {
			if (!CaptureProviderHelpers.isCaptureProvider(field)) {
				return;
			}

			const fieldCaptures = field.getCaptures() || [];
			for (const fieldCapture of fieldCaptures) {
				collections.push(fieldCapture);
			}
		});

		return collections;
	}

	static getCaptureIds(c: CollectionModel | null): string[] {
		if (!c) {
			return [];
		}

		const collections: string[] = [];

		c.forEachField((field) => {
			if (!CaptureProviderHelpers.isCaptureProvider(field)) {
				return;
			}

			const fieldCaptures = field.getCaptureIds() || [];
			for (const fieldCapture of fieldCaptures) {
				collections.push(fieldCapture);
			}
		});

		return collections;
	}
}
